import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filterList",
  "use": "filterList-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"filterList\"><path d=\"m3 5 .5 2h11l.5-2zm4.5 8h3l.5-2H7zm-2-3h7l.5-2H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol